import { useState } from 'react';
import { useSelector } from 'react-redux';
import Offcanvas from 'olive-react-myoneui/lib/Offcanvas';

function OffcanvasMessages({ triggerTitle, triggerSubTitle, messageCount, setMessageCount }) {
  const [show, setShow] = useState(false);
  const access_token    = useSelector((state) => state.config.access_token);
  const configData      = useSelector((state) => state.config);

  const handleClose = () => {
    setShow(false);
    setMessageCount("")
  }
  const handleShow = () => {
    setShow(true);
    setMessageCount("")
  }

  const offCanvasKeyDown = (e) => e.stopPropagation();
  let current_url = window.location.origin

  return (
    <>
      <span className={`${messageCount > 0 ? `mk-show-dot nav-link` : ""} nav-link`} onClick={handleShow}>
        {triggerTitle} {triggerSubTitle}
      </span>
      <Offcanvas show={show} onHide={handleClose} placement="end" className="w-75 pb-0" onKeyDown={offCanvasKeyDown}>
        <Offcanvas.Header closeButton backButton className="pb-4 messages-header">
          <Offcanvas.Title>Messages</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0 ps-4 pe-0 pb-0">
          <iframe title="message service" height="100%" width="100%" src={`${configData.messageBaseUrl}/?auth_url=${current_url}/content/get_user_data/${access_token}`}></iframe>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default OffcanvasMessages;
